<template>
  <svg width="27" height="27" viewBox="0 0 27 27" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
    <circle cx="13.5" cy="13.5" r="12.5" stroke-width="2" />
    <path
      fill="currentColor"
      d="M9.00017 13.9838C9.00261 13.6479 9.12395 13.3263 9.3385 13.0869L14.9872 6.88108C15.2076 6.63784 15.507 6.50077 15.8194 6.5C16.1318 6.49924 16.4317 6.63486 16.6531 6.87703C16.8745 7.11919 16.9993 7.44807 17 7.7913C17.0007 8.13454 16.8772 8.46402 16.6568 8.70726L11.8392 14L16.6568 19.2927C16.8772 19.536 17.0007 19.8655 17 20.2087C16.9993 20.5519 16.8745 20.8808 16.6531 21.123C16.4317 21.3651 16.1318 21.5008 15.8194 21.5C15.507 21.4992 15.2076 21.3622 14.9872 21.1189L9.3385 14.9131C9.22873 14.7907 9.14227 14.6454 9.08418 14.4859C9.02609 14.3263 8.99753 14.1557 9.00017 13.9838Z"
    />
  </svg>
</template>
